export var wmsServer =
  'https://mapgateway-aws.findmaps.co.uk/wms/searchacumen/jxq6fI4tR0g9eTu4?tiled=true&trk=-6&clientid=-6';
export var layerServer = 'https://wmsgateway.findmaps.co.uk/wms/mapdesk/RwM6Q2kkKnuSdxMx?tiled=true&trk=-6&clientid=-6';
export var layerServer2 =
  'https://mapgateway-aws.findmaps.co.uk/wms/searchacumen/jxq6fI4tR0g9eTu4?tiled=true&trk=-6&clientid=-6';
export var layerServer3 = 'https://sacomm.findmaps.co.uk/cgi-bin/mapserv?map=sa.map';
export var aerialServer = 'https://wmsgateway.findmaps.co.uk/wms/maplet/RwM6Q2kkKnuSdxMx?tiled=true&trk=-6&clientid=-6';
export var fayeServer = 'https://node.inverherive.co.uk/faye';
export var wmslayers = {
  mastermap: 'OS:OS Mastermap (Live) 100', //OS:OS Mastermap (Live) FG (Maplet)",
  oml: 'OS:Open Map Local (Live)',
  vml: 'OS:Vector Map Local (Backdrop)', //Vector Map Local (Live)",
  vmd: 'OS:Vector Map District (Live)',
  aerial: 'composite_best_UK_250mm',
  mastermapbw: 'OS Mastermap (Live) BW 100',
  omlbw: 'OS:Open Map Local (Live) BW',
  vmlbw: 'OS:Open Map Local (Live) BW',
  vmdbw: 'OS:Vector Map District (Live) BW',
};
export var alternateLayers = {
  he_scheduledmonuments: 'he_scheduledmonuments_26_01_2018',
  vw_rofrs: 'ea_flood',
};
export var layerprefix = '';
export var skipPlanningLog = false;
export var landinsightAPIKey = '$2a$10$1tDFB5TnU.7XahhAI3c5v.NyXB2lg6PyBWX/uzeiBnjMB1hHNKyvK'; //'$2a$10$1tDFB5TnU.7XahhAI3c5v.NyXB2lg6PyBWX/uzeiBnjMB1hHNKyvK'
export var baseURL = 'https://sacomm.inverherive.co.uk';
export var layerProxy = baseURL + '/proxy';
//var landinsightAPIKey = "$2a$10$1tDFB5TnU.7XahhAI3c5v.NyXB2lg6PyBWX/uzeiBnjMB1hHNKyvK";
export var maxSnapshot = 100000000;
